import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { from, map, Observable, switchMap } from "rxjs";
import { RolesService } from "aih-launchpad-core";
import { Announcement, AnnouncementContent } from './announcement';

@Injectable({
  providedIn: 'root'
})

export class AnnouncementService {
  apiUrl = ''; // bff api for announcements
  private mockData = './assets/mock/announcements.json';

  constructor(private http: HttpClient, private rolesService: RolesService) { }

  getAnnouncements(lang: string): Observable<AnnouncementContent[]> {
    // use mocked data from json and filter based on organisation
    return from(this.rolesService.getPlatforms()).pipe(
      switchMap(platforms =>
        this.http.get<Announcement[]>(this.mockData)
          .pipe(
            map(items => items.filter(i => platforms.includes(i.platform) && !!i.content[lang])),
            map(items => items.flatMap(i => i.content[lang]!))
          )
      ));
  }
}
